
import { defineComponent, onMounted, ref } from 'vue'
import { Carousel, Pagination, Slide } from 'vue3-carousel'
import OrangeButton from '@/components/Buttons/OrangeButton.vue'

import 'vue3-carousel/dist/carousel.css'

export default defineComponent({
  components: {
    Slide,
    Carousel,
    Pagination,
    OrangeButton,
  },
  setup() {
    const challenges = ref([
      {
        title: 'Antigo Testamento',
        subtitle: 'Em breve',
        route: '/',
        active: false,
      },
      {
        title: 'Versículos do Novo Testamento',
        subtitle:
          'Acerte o máximo de <strong>referências bíblicas</strong> que conseguir no <strong>Novo Testamento</strong>.',
        route: '/multipla-escolha/novo-testamento',
        active: true,
      },
      {
        title: 'Perguntas Bíblicas',
        subtitle:
          'Perguntas e respostas sobre as escrituras para <strong>aumentar o seu conhecimento Bíblico</strong>!',
        route: '/multipla-escolha/quiz',
        active: true,
      },
    ])

    const currentSlide = ref<undefined | number>(undefined)

    onMounted(() => {
      currentSlide.value = 1
    })

    return {
      challenges,
      currentSlide,
      smallWindow: window.innerWidth < 777,
    }
  },
})
